import { Component, Input } from '@angular/core';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { DashboardCard } from '../../shared/models';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class DashboardCardComponent {
  @Input() card: DashboardCard;
  private stateMetrics = 'auth.alcmeon.fuse.metrics-and-reports.metrics';

  constructor(private customRouter: CustomRouter) {}

  goToMetrics(metricId: number) {
    this.customRouter.go(this.stateMetrics, {
      metricId: metricId,
    });
  }
}
